// extracted by mini-css-extract-plugin
export default {"youtube-embed":"YoutubeEmbed_youtube-embed__ljkZv"};